import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { DtoUpdateQuoteDocument } from '../models/DtoUpdateQuoteDocument';
import { GetRoles } from '../models/GetRoles';
import { FindQuote } from '../models/leasing/FindQuote';
import { ResponseBase } from '../models/ResponseBase';
import { BranchOffices } from '../models/leasing/BranchOffices';
import { QuoteProperty } from '../models/leasing/QuoteProperty';
import { QuoteContact } from '../models/leasing/QuoteContacts';
import { FindLinkQuotePersonResponse } from '../models/leasing/FindLinkQuotePerson';
import { UpdateQuoteContactRequest } from '../models/leasing/UpdateQuoteContact';
import { AddOrUpdatePropertyByQuoteRequest } from '../models/leasing/AddOrUpdatePropertyByQuote';
import { AddOrUpdateLinkQuotePersonRequest } from '../models/leasing/AddOrUpdateLinkQuotePerson';
import { DocumentRequiredRole } from '../models/leasing/FindDocumentsRequiredByTypePersonByRole';
import { AddQuoteContactRequest, AddQuoteContactResponse } from '../models/leasing/AddQuoteContact';
import { DocumentUploaded } from '../models/leasing/DocumentsUploadedByRole';
import { AddQuoteDocumentRequest } from '../models/leasing/AddQuoteDocument';
import { ReferenceType } from '../models/leasing/ReferenceType';
import { AddPropertiesVehiclesByRole } from '../models/leasing/AddPropertiesVehiclesByRole';
import { AddSpouse } from '../models/leasing/AddSpouse';
import { ReferenceRequest, ReferenceResponse, ResponseDto } from '../models/leasing/ReferenceRequest';
import { PropertiesVehiclesResponse } from '../models/leasing/PropertiesVehiclesResponse ';
import { ApiResponse } from '../models/ResponseAZLeasing';
import { Opportunity } from '../models/Opportunity';
import { ValidateForm } from '../models/leasing/ValidateForm';
import { ApiResponseValidateForm } from '../models/leasing/ApiResponseValidateForm';
import { DatosBasicos } from '../models/leasing/createPerson/DatosBasicos';
import { Cargo } from '../models/leasing/Cargo';

@Injectable({
  providedIn: 'root',
})
export class LeasingService {
  urlLeasing: string = environment.UrlServices.API_Leasing;

  constructor(private http: HttpClient) {}

  FindQuoteDocumentsUploadedByIdRole(InIdRole: number,InIdQuoteHeader: number): Observable<ResponseBase<DocumentUploaded[]>> {
    return this.http.get<ResponseBase<DocumentUploaded[]>>(
      `${this.urlLeasing}/api/QuoteDocuments/FindQuoteDocumentsUploadedByIdRole?InIdRole=${InIdRole}&InIdQuoteHeader=${InIdQuoteHeader}`
    );
  }

  UpdateProcessQuoteDocument(
    quoteDocument: DtoUpdateQuoteDocument
  ): Observable<any> {
    return this.http.post<any>(
      `${this.urlLeasing}/api/QuoteDocuments/UpdateProcessQuoteDocument`,quoteDocument
    );
  }

  FindQuote(inIdQuoteHeader: number): Observable<ResponseBase<FindQuote>> {
    return this.http.get<ResponseBase<FindQuote>>(
      `${this.urlLeasing}/api/Quotes/FindQuote?InIdQuoteHeader=${inIdQuoteHeader}`);
  }

  GetRoles(): Observable<ResponseBase<GetRoles>> {
    return this.http.get<ResponseBase<GetRoles>>(
      `${this.urlLeasing}/api/Settings/GetRoles`
    );
  }

  FindQuotesHeaderByOwner(email?: string, telephone?: string): Observable<any> {
    let queryParams = '';
    if (email) {
      queryParams += `email=${email}`;
    }
    if (telephone) {
      queryParams += `telephone=${telephone}`;
    }
    return this.http.get<any>(
      `${this.urlLeasing}/api/Quotes/FindQuotesHeaderByOwner?${queryParams}`
    );
  }

  FindBranchOfficesByQuoteHeader(inIdQuoteHeader: number): Observable<ResponseBase<BranchOffices>> {
    return this.http.get<ResponseBase<BranchOffices>>(
      `${this.urlLeasing}/api/BranchOffices/FindBranchOfficesByQuoteHeader?InIdQuoteHeader=${inIdQuoteHeader}`);
  }

  GetNaturalPersonTypes(): Observable<any> {
    return this.http.get<any>(
      `${this.urlLeasing}/api/Settings/GetNaturalPersonTypes`
    );
  }

  GetReferenceTypes(): Observable<ResponseBase<ReferenceType>> {
    return this.http.get<ResponseBase<ReferenceType>>(
      `${this.urlLeasing}/api/References/GetReferenceTypes`
    );
  }

  GetAllSettings(): Observable<any> {
    return this.http.get<any>(`${this.urlLeasing}/api/Settings/GetAllSettings`);
  }

  SendEmailCodeAuthotization(inIdQuoteHeader: number): Observable<any> {
    return this.http.get<any>(
      `${this.urlLeasing}/api/Quotes/SendEmailCodeAuthotization?InIdQuoteHeader=${inIdQuoteHeader}`);
  }

  ValidateCodeAuthotization(inIdQuoteHeader: number, inCodeAuthorization: number): Observable<any> {
    return this.http.get<any>(
      `${this.urlLeasing}/api/Quotes/ValidateCodeAuthorization?InIdQuoteHeader=${inIdQuoteHeader}&InCodeAuthorization=${inCodeAuthorization}`);
  }

  FindPropertyByQuoteHeader(inIdQuoteHeader: number): Observable<ResponseBase<QuoteProperty>> {
    return this.http.get<ResponseBase<QuoteProperty>>(
      `${this.urlLeasing}/api/QuoteProperties/FindPropertyByQuoteHeader?InIdQuoteHeader=${inIdQuoteHeader}`);
  }
  
  FindContactsByQuoteHeader(inIdQuoteHeader: number): Observable<ResponseBase<QuoteContact[]>> {
    return this.http.get<ResponseBase<QuoteContact[]>>(
      `${this.urlLeasing}/api/QuoteContacts/FindContactsByQuoteHeader?InIdQuoteHeader=${inIdQuoteHeader}`);
  }

  FindLinkQuotePerson(inIdQuoteHeader: number, inIdRole: number): Observable<ResponseBase<FindLinkQuotePersonResponse>> {
    return this.http.get<ResponseBase<FindLinkQuotePersonResponse>>(
      `${this.urlLeasing}/api/QuoteContacts/FindLinkQuotePerson?InIdQuoteHeader=${inIdQuoteHeader}&InIdRole=${inIdRole}`);
  }

  UpdateQuoteContact(updateContactQuote: UpdateQuoteContactRequest): Observable<ResponseBase<any>> {
    return this.http.post<any>(
      `${this.urlLeasing}/api/QuoteContacts/UpdateQuoteContact`,updateContactQuote
    );
  }

  AddQuoteContact(addQuoteContact: AddQuoteContactRequest): Observable<ResponseBase<AddQuoteContactResponse>> {
    return this.http.post<any>(
      `${this.urlLeasing}/api/QuoteContacts/AddQuoteContact`,addQuoteContact
    );
  }

  AddOrUpdatePropertyByQuoteHeader(updateContactQuote: AddOrUpdatePropertyByQuoteRequest): Observable<ResponseBase<any>> {
    return this.http.post<any>(
      `${this.urlLeasing}/api/QuoteProperties/AddOrUpdatePropertyByQuoteHeader`,updateContactQuote
    );
  }

  AddOrUpdateLinkQuotePerson(updateContactQuote: AddOrUpdateLinkQuotePersonRequest): Observable<ResponseBase<any>> {
    return this.http.post<any>(
      `${this.urlLeasing}/api/QuoteContacts/AddOrUpdateLinkQuotePerson`,updateContactQuote
    );
  }

  FindDocumentsRequiredByTypePersonByRole(strPersonType: string, inIdRole: number, inIdNaturalPersonType: number): Observable<ResponseBase<DocumentRequiredRole[]>> {
    return this.http.get<ResponseBase<DocumentRequiredRole[]>>(
      `${this.urlLeasing}/api/QuoteDocuments/FindDocumentsRequiredByTypePersonByRole?strPersonType=${strPersonType}&InIdRole=${inIdRole}&InIdNaturalPersonType=${inIdNaturalPersonType}`);
  }
 
  AddQuoteDocument(addQuoteDocument: AddQuoteDocumentRequest): Observable<ResponseBase<any>> {
    return this.http.post<any>(
      `${this.urlLeasing}/api/QuoteDocuments/AddQuoteDocument`,addQuoteDocument
    );
  }

  SendLinkPersonEmail(phone: number, email: string, inIdRole: number, link: string, quoteNumber: number, strRol: string): Observable<ResponseBase<any>> {
    return this.http.get<ResponseBase<any>>(
      `${this.urlLeasing}/api/QuoteContacts/SendLinkPersonEmail?StrTelephoneNumber=${phone}&StrEmail=${email}&InIdRole=${inIdRole}&quoteHeader=${quoteNumber}&StrRole=${strRol}&StrLink=${link}`);
  }

  AddOrUpdatePropertiesVehiclesByRol(dto: AddPropertiesVehiclesByRole): Observable<ResponseBase<any>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  
    return this.http.post<ResponseBase<any>>(
      `${this.urlLeasing}/api/RoleProperties/AddOrUpdatePropertiesVehiclesByRol`,
      dto,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('Error en AddOrUpdatePropertiesVehiclesByRol:', error);
        return throwError(() => new Error('Error al crear la AddOrUpdatePropertiesVehiclesByRol.'));
      })
    );
  }

  AddSpouseByQuoteHeader(spouseData: AddSpouse): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post<any>(`${this.urlLeasing}/api/Spouse/AddSpouseByQuoteHeader`, spouseData, { headers }).pipe(
      catchError((error) => {
        console.error('Error en AddSpouseByQuoteHeader:', error);
        return throwError(() => new Error('Error al enviar los datos del cónyuge.'));
      })
    );
  }
  
  addReferences(references: ReferenceRequest[]): Observable<ResponseDto<ReferenceResponse[]>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<ResponseDto<ReferenceResponse[]>>(`${this.urlLeasing}/api/References/AddReferencesByRoleByQuoteHeader`, references, { headers })
      .pipe(
        map(response => {
          if (!response.status) {
            throw new Error(response.msn || 'Error en la solicitud');
          }
          return response;
        }),
        catchError(error => {
          console.error('Error en la API', error);
          throw error;
        })
      );
  }

  getReferences(inIdRole: number, inIdQuoteHeader: number): Observable<ReferenceResponse[]> {
    const params = new HttpParams()
      .set('inIdRole', inIdRole.toString())
      .set('inIdQuoteHeader', inIdQuoteHeader.toString());

    return this.http.get<ReferenceResponse[]>(`${this.urlLeasing}/api/References/FindReferencesByRoleByQuoteHeader`, { params })
      .pipe(
        catchError(error => {
          console.error('Error al obtener referencias:', error);
          throw error;
        })
      );
  }

  getPropertiesVehicles(inIdRole: number, inIdQuoteHeader: number): Observable<PropertiesVehiclesResponse> {
    const params = new HttpParams()
      .set('inIdRole', inIdRole.toString())
      .set('inIdQuoteHeader', inIdQuoteHeader.toString());

    return this.http.get<ResponseDto<PropertiesVehiclesResponse>>(`${this.urlLeasing}/api/RoleProperties/FindPropertiesVehiclesByRoleByQuoteHeader`, { params }).pipe(
      map(response => {
        if (!response.status) {
          throw new Error(response.msn || 'Error en la respuesta del servidor');
        }
        return response.value;
      }),
      catchError(error => {
        console.error('Error al obtener propiedades y vehículos:', error);
        throw error;
      })
    );
  }

  getSpouseByQuoteHeader(inIdQuoteHeader: number): Observable<AddSpouse[]> {
    const params = new HttpParams().set('inIdQuoteHeader', inIdQuoteHeader.toString());

    return this.http.get<ResponseDto<AddSpouse[]>>(`${this.urlLeasing}/api/Spouse/FindSpouseByQuoteHeader`, { params }).pipe(
      map(response => {
        if (!response.status) {
          throw new Error(response.msn || 'Error en la respuesta del servidor');
        }
        return response.value; 
      }),
      catchError(error => {
        console.error('Error al obtener datos del cónyuge:', error);
        throw error;
      })
    );
  }

  createValidateForm(validateForm: ValidateForm): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.urlLeasing}/api/Quotes/ValidateForms`, validateForm);
  }

  getValidateFormsByQuotationNumber(quotationNumber: number): Observable<ApiResponseValidateForm> {
    return this.http.get<ApiResponseValidateForm>(`${this.urlLeasing}/api/Quotes/ValidateForms/${quotationNumber}`);
  }
  
  getCargos(): Observable<ResponseBase<Cargo[]>> {
    return this.http.get<ResponseBase<Cargo[]>>(
      `${this.urlLeasing}/api/Quotes/Cargo`
    );
  }


  sendOpportunity(opportunity: Opportunity): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.urlLeasing}/api/Quotes/ReceiveInputData`, opportunity);
  }

  GenerateFuccDocument(InIdQuoteHeader: number, role: number): Observable<ResponseBase<any>> {
    return this.http.get<ResponseBase<any>>(
      `${this.urlLeasing}/api/FuccReports/GenerateFuccDocument?InIdQuoteHeader=${InIdQuoteHeader}&InIdRole=${role}`);
  }

  saveFormulario(datos: DatosBasicos): Observable<ResponseBase<any>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<ResponseBase<any>>(
      `${this.urlLeasing}/api/Formulario/guardar-persona`,
      datos,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('Error al guardar el formulario:', error);
        return throwError(() => new Error('Error al guardar el formulario.'));
      })
    );
  }

    saveFormularioSISE(datos: DatosBasicos): Observable<ResponseBase<any>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<ResponseBase<any>>(
      `${this.urlLeasing}/api/Formulario/guardar-persona-sise`,
      datos,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('Error al guardar el formulario:', error);
        return throwError(() => new Error('Error al guardar el formulario.'));
      })
    );
  }
}